import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "./baseService.service";

@Injectable({
  providedIn: 'root'
})
export class AttachmentService {
  // httpOptions = {
  //   headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  // };
  httpOptions: any;
  AttachmentAPIConstant = `FileAttachment`;
  DownloadAttachmentConstant = `FileAttachment/DownloadAttachment`;
  mediaHeader: any;
  constructor(private baseService: BaseService) {
    /* this.httpOptions = {
      headers: new HttpHeaders({
          'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data'
      })
  }; */
    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    this.mediaHeader = new HttpHeaders().set('Content-Type', 'multipart/form-data');
    //this.mediaHeader = this.mediaHeader.append('Authorization',`Bearer ${sessionStorage.getItem('accessToken')}`);
  }

  saveAttachment(file: FormData) {
    return this.baseService.post(`${this.AttachmentAPIConstant}/Upload-Multiple`, file, this.mediaHeader);
  }

  getAttachment(fileName: string,flag: boolean = false) {
    return this.baseService.get(`${this.AttachmentAPIConstant}/${fileName}`, { responseType: 'Blob' });
  }

  downloadAttachmentById(fileId: any,flag: boolean = false) {

    const params = new HttpParams()
      .set('fileid', fileId)
      .set('isCommentHistory', String(flag));

    return this.baseService.get(
      this.DownloadAttachmentConstant,
      { params, responseType: 'blob' }
    );
  }

  deleteAttachment(fileName: string) {
    return this.baseService.delete(`${this.AttachmentAPIConstant}/${fileName}`, this.httpOptions);
  }
}
